/**
 * Shared Module
 *
 * TypeScript
 * @author        Ollie Lowson ( @ollielowson )
 * @copyright    2016-2019 System 15 Limited
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { WaitingSpinnerComponent } from './waiting-spinner/waiting-spinner.component';

import { DateFormatPipe } from '../pipes/date-format.pipe';
import { DateTimeFormatPipe } from '../pipes/date-time-format.pipe';
import { FilterPipe } from '../pipes/filter.pipe';
import { FromNowPipe } from '../pipes/from-now.pipe';
import { WarrantyPointsPipe } from '../pipes/warranty-points.pipe';

@NgModule({
  imports: [
    CommonModule,

    MatProgressBarModule,
    MatProgressSpinnerModule,
  ],
  declarations: [
    WaitingSpinnerComponent,
    DateFormatPipe,
    DateTimeFormatPipe,
    FilterPipe,
    FromNowPipe,
    WarrantyPointsPipe,
  ],
  exports: [
    WaitingSpinnerComponent,
    DateFormatPipe,
    DateTimeFormatPipe,
    FilterPipe,
    FromNowPipe,
    WarrantyPointsPipe,
  ]
})
export class SharedModule { }
